import {
  TableRow,
  TableCell,
  Skeleton,
  styled,
  tableCellClasses,
} from "@mui/material";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#003766",
    color: theme.palette.primary.contrastText,
    fontWeight: "bold",
    position: "sticky",
    top: 0,
    zIndex: 1,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
  border: "1px solid #e0e0e0",
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: theme.palette.action.hover,
  },
}));

const MunicipalitiesTableSkeleton = () => {
  const skeletonRows = Array.from({ length: 5 }, (_, index) => index);

  return (
    <>
      {skeletonRows.map((index) => (
        <StyledTableRow key={index}>
          <StyledTableCell>
            <Skeleton variant="text" width="80%" height={20} />
          </StyledTableCell>
          <StyledTableCell>
            <Skeleton variant="text" width="80%" height={20} />
          </StyledTableCell>
          <StyledTableCell>
            <Skeleton variant="text" width="90%" height={20} />
          </StyledTableCell>
          <StyledTableCell>
            <Skeleton variant="rectangular" width="60px" height={24} />
          </StyledTableCell>
          <StyledTableCell>
            <Skeleton variant="text" width="70%" height={20} />
          </StyledTableCell>
          <StyledTableCell>
            <Skeleton variant="rectangular" width="50px" height={20} />
          </StyledTableCell>
          <StyledTableCell>
            <Skeleton variant="text" width="85%" height={20} />
          </StyledTableCell>
          <StyledTableCell>
            <Skeleton variant="text" width="100%" height={20} />
            <Skeleton variant="text" width="80%" height={20} />
            <Skeleton variant="text" width="60%" height={20} />
          </StyledTableCell>
          <StyledTableCell>
            <Skeleton variant="rectangular" width="100%" height={40} />
          </StyledTableCell>
          <StyledTableCell>
            <Skeleton variant="rectangular" width="80px" height={32} />
          </StyledTableCell>
        </StyledTableRow>
      ))}
    </>
  );
};

export default MunicipalitiesTableSkeleton;
